import { Injectable } from '@angular/core';

@Injectable()
export abstract class Resetable {
  /**
   * Resets a service to a default state
   */
  public abstract reset(): Promise<void>;

  /**
   * Clears a services all data
   */
  public abstract clear(): Promise<void>;
}
